import { render } from "./dermatology_imaging.vue?vue&type=template&id=500821ca&scoped=true"
import script from "./dermatology_imaging.vue?vue&type=script&lang=js"
export * from "./dermatology_imaging.vue?vue&type=script&lang=js"

import "./dermatology_imaging.vue?vue&type=style&index=0&id=500821ca&scoped=true&lang=css"

import exportComponent from "/home/denoh/aiwork/second/in_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-500821ca"]])

export default __exports__